module.exports = __webpack_public_path__ + "media/images/contact_hero-image@2x-f382afd09fd8e7f209e858c933f7b89e.jpg";